import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output } from "@angular/core";
import { FormArray, FormGroup, FormGroupDirective } from "@angular/forms";

import { EventEmitterHelper } from "@tylertech/shared-module";
import { INote } from "@tylertech/tyler-api-types";

@Component({
    selector: "notes",
    templateUrl: "./notes.tmpl.html",
    standalone: false
})
export class NotesComponent
    implements OnDestroy, OnInit
{
    @Input() readonly hideSubject: boolean;

    @Input() readonly model: Array<INote>;
    @Output() readonly modelChange = new EventEmitter<Array<INote>>();

    @Input() readonly viewOnly: boolean;

    @Output() readonly delete = new EventEmitter<INote>();

    constructor(
        @Optional() private readonly formGroupDirective?: FormGroupDirective)
    { }

    private get parentFormGroup(): FormGroup | undefined { return this.formGroupDirective?.form; }

    get hasNotes(): boolean
    {
        return this.model?.length > 0;
    }

    get CanDelete(): boolean
    {
        return EventEmitterHelper.hasSubscribers(this.delete);
    }

    ngOnDestroy(): void
    {
        if (this.parentFormGroup)
        {
            this.parentFormGroup.removeControl("notes");
        }
    }

    ngOnInit(): void
    {
        if (!this.model || this.model.length === 0)
        {
            this.modelChange.emit([{} as INote]);
        }

        if (this.parentFormGroup)
        {
            this.parentFormGroup.addControl("notes", new FormArray([]));
        }
    }

    deleteNote(note: INote): void
    {
        if (!this.CanDelete)
        {
            return;
        }

        this.delete.emit(note);
    }
}
